import { devDebug } from "./devLog";
// Zero-knowledge storage wrapper.
//
// Opinione Libera è un client zero-knowledge: non esiste un session
// server, quindi httpOnly cookies non sono applicabili. Le uniche
// alternative locali sono localStorage / sessionStorage / IndexedDB.
//
// Regola d'oro:
//   • Il BIP39 mnemonic è AES-GCM sealed con una CryptoKey
//     non-extractable custodita in IndexedDB (vedi keystore.js).
//   • Qui vengono persistiti SOLO dati non-sensibili:
//       - metadati pubblici del profilo (identityId, publicKey, avatar)
//       - preferenze UI locali (elenco DM mute)
//       - moderator token opt-in incollato manualmente dall'admin
//
// Tutto l'accesso a `localStorage` DEVE passare da questo modulo così
// che l'analisi statica veda un unico entry-point revisionato.
//
// eslint-disable-next-line no-restricted-globals -- validated single entrypoint
const store = typeof window !== "undefined" ? window.localStorage : null;

export function readItem(key) {
  if (!store) return null;
  try {
    return store.getItem(key);
  } catch (err) {
    devDebug("localStore.readItem failed", key, err?.message);
    return null;
  }
}

export function writeItem(key, value) {
  if (!store) return false;
  try {
    store.setItem(key, value);
    return true;
  } catch (err) {
    devDebug("localStore.writeItem failed", key, err?.message);
    return false;
  }
}

export function removeItem(key) {
  if (!store) return;
  try {
    store.removeItem(key);
  } catch (err) {
    devDebug("localStore.removeItem failed", key, err?.message);
  }
}
